// extracted by mini-css-extract-plugin
export default {"page":"profile-page_page__yjchR","pageContent":"profile-page_pageContent__ZaRok","main":"profile-page_main__uK-WV","mainContent":"profile-page_mainContent__DGRGt"};